
/**
 * @file   src\components\GenerateLink.tsx
 * @brief Generate app URL component.
 * @date   AUGUST, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { Button, useEffect, useState, Modal } from '../utils/thirdpartyComponents';
import CWInput from './CWInput';
import '../components/CWModal.scss';
import { MessageToaster } from "../utils/toastUtil";
import axios from '../config/axiosConfig';
import SmallLoader from '../components/SmallLoader';
import copy from "clipboard-copy"
import CopyIcon from '../assets/images/icons/copy';
import { CompanyApi } from '../utils/apiUrls';
import QRCodeComponent from '../components/QRCodeComponent';
import { userType } from '../utils/enums';
import { isUnitedStates } from '../utils/countryState';

const GenerateLink = (props: any) => {
    // State to handle generated link
    const [generatedLink, setGeneratedLink] = useState('');
    const [carwashGuid, setCarwashGuid] = useState<string | null>(null);
    const [hasUrlPermission, setHasUrlPermission] = useState(1);
    const toaster = new MessageToaster();
    const [loading, setLoading] = useState(false);
    const carwash_owner = (props.carwash_owner) ? props.carwash_owner : false;

    // initial loading
    useEffect(() => {
        setCarwashGuid(props.companyDetails?.carWashGUID);
       
        let urlGeneratePermission = props.companyDetails?.hasUrlPermission;
        if (carwash_owner && !props.companyDetails?.carWashURL) {
            urlGeneratePermission = false;
        } else if (!carwash_owner && props.companyCountry && !isUnitedStates(props.companyCountry)) {
            urlGeneratePermission = true;
        }
        setHasUrlPermission(urlGeneratePermission);
        const carwashUrl = props.companyDetails?.carWashURL ? `${process.env.REACT_APP_CARWASH_APP_BASE_URL || ""}${props.companyDetails?.carWashURL}`:""
        setGeneratedLink(carwashUrl)
    }, [props])

    const handleCopyLink = () => {
        // copy link
        copy(generatedLink);
        // show success message
        toaster.toastSuccess("URL copied to clipboard!")

    };

    // Generate app Link
    const generateLink = async () => {
        try {
            if (carwashGuid) {
                setLoading(true)
                const requestParam = {
                    carWashGuid: carwashGuid
                }
                const { data } = await axios.post(CompanyApi.GENERATE_APP_URL, requestParam)
                if (data?.error === 0) {
                    setGeneratedLink(data?.data?.appUrl ? `${process.env.REACT_APP_CARWASH_APP_BASE_URL || ""}${data?.data?.appUrl}`:"");
                }
                setLoading(false)
            }

        } catch (error: any) {
            throw new Error(error.response?.data?.message || error.message);
        }
    }

    const [showqrcodeModal, setShowqrcodeModal] = useState(false);
    const Generateqr = () => {
        setShowqrcodeModal(true);
    }
    const hideqrmodelModal = () =>{
        setShowqrcodeModal(false);
    }


    return (
        <>
            {hasUrlPermission ? <div className="app-field-group d-flex align-items-center">
            <div className='copy-input d-flex align-items-center'>
                <CWInput
                    id="appurl"
                    name="appurl"
                    type="text"
                    label="Mobile App URL"
                    value={generatedLink}
                    disabled

                />
                {/* <span className="icon" onClick={handleCopyLink}><CopyIcon /></span> */}
            </div>
                {generatedLink=== "" ? <Button
                    title='Generate URL'
                    type="submit"
                    variant="primary"
                    className="primary-btn"
                    onClick={() => generateLink()}
                    disabled={generatedLink != "" ? true : false}
                >
                Generate Link
            </Button> : <><Button
                    title='Copy URL'
                    type="submit"
                    variant="primary"
                    className="primary-btn"
                    onClick={handleCopyLink}
                >
                Copy URL
            </Button>
            <Button
                    title='Download QR Code'
                    type="button"
                    variant="primary"
                    className="primary-btn"
                    onClick={() => { Generateqr() }}
                >
                Download QR Code
            </Button>
            </>}
            {loading && <SmallLoader />}
            </div> : ""}

            <Modal
                show={showqrcodeModal}
                onHide={hideqrmodelModal}
                centered
                className='add-modal'
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>QR Code of PWA App</h5>
                    <div className="btn-sec">
                        <QRCodeComponent 
                        value={generatedLink}
                        equipment_name={generatedLink} 
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
        
    );
};
export default GenerateLink;



